import Icon from '@cobliteam/colib-ui/Icon';
import Typography from '@cobliteam/colib-ui/Typography';
import { useTranslation } from '@cobliteam/i18n';

type InactiveFleetBannerProps = {
  /** A dica de trocar de frota só faz sentido quando o usuário tem alguma frota ativa para ir. */
  showSwitchFleetHint: boolean;
};

/**
 * Banner fixo exibido no topo da página de boletos quando a frota está inativa
 * (pendência de pagamento ou cancelamento): todo o resto do painel fica inacessível.
 */
const InactiveFleetBanner = ({ showSwitchFleetHint }: InactiveFleetBannerProps) => {
  const { t } = useTranslation('business-manager');

  return (
    <div role='alert' data-testid='inactive-fleet-banner' className='flex items-start gap-3 border-destructive border-b bg-destructive/10 px-6 py-4'>
      <Icon name='triangle-alert' size='md' className='mt-0.5 shrink-0 text-destructive' />
      <div className='flex flex-col gap-1'>
        <Typography variant='body' className='gap-1 break-words font-semibold text-destructive text-foreground'>
          {t('inactive_fleet.banner.title')}
        </Typography>
        <Typography variant='caption' className='gap-1 break-words text-destructive text-foreground'>
          {t('inactive_fleet.banner.description')}
        </Typography>
        {showSwitchFleetHint && (
          <Typography variant='caption' data-testid='inactive-fleet-banner-switch-hint' className='gap-1 break-words text-destructive text-foreground'>
            {t('inactive_fleet.banner.switch_fleet_hint')}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default InactiveFleetBanner;
